module.exports = __webpack_public_path__ + "static/tribes-2ca62d6a17388dc5ab43b8ae98a36e6c.jpg";